export const FIELD_FORM_ID = 'engine_field_detail_form';
export const ENGINE_FORM_ID = 'engine_detail_form';
